import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import {
  MenuBookings,
  MenuDashboard,
  MenuInvitePartner,
  MenuMyCompany,
  MenuMyProfile,
  MenuMySuppliers,
  MenuOrders,
  MenuShipments,
  MenuMyCustoms,
} from '../Components/icons/left-menu';
import { giveProfile } from '../Components/global-notification/notification-list';
import MENU_SCHEMA_QUERY from '../graphQL/menuSchema';
import { EntityIcon } from '../Components/icons/my-company';
import usePermissionTabs from '../helpers/centralized-permissions';
import { TimezoneIcon } from '../Components/icons/icons';
import { checkPermission } from '../helpers/permissionHelper';

const menuSchema = () => {
  const { relation, companyId } = useParams();
  const [globalMenu, setGlobalMenu] = useState([]);
  const [relationalMenu, setRelationalMenu] = useState([]);

  const [getMenuSchema] = useLazyQuery(MENU_SCHEMA_QUERY);
  const {
    displayMyEntitiesTab,
    displayTimelineTab,
    hideMySuppliersTab,
    hideCustomsMenu,
    showCreateSingleOrder,
  } = usePermissionTabs();

  /**
   * @method iconMaster
   */

  const iconMaster = (icon) => {
    let iconMenu = '';
    switch (icon) {
      case 'MenuBookings':
        iconMenu = <MenuBookings />;
        break;
      case 'MenuDashboard':
        iconMenu = <MenuDashboard />;
        break;
      case 'MenuDashbaord':
        iconMenu = <MenuDashboard />;
        break;
      case 'MenuInvitePartner':
        iconMenu = <MenuInvitePartner />;
        break;
      case 'MenuMyCompany':
        iconMenu = <MenuMyCompany />;
        break;
      case 'MenuMyProfile':
        iconMenu = <MenuMyProfile />;
        break;
      case 'MenuMySuppliers':
        iconMenu = <MenuMySuppliers />;
        break;
      case 'MenuOrders':
        iconMenu = <MenuOrders />;
        break;
      case 'MenuShipments':
        iconMenu = <MenuShipments />;
        break;
      case 'EntityIcon':
        iconMenu = <EntityIcon color="#CDD1D1" />;
        break;
      case 'MyTimeline':
        iconMenu = <TimezoneIcon color="#CDD1D1" />;
        break;
      case 'MyCustoms':
        iconMenu = <MenuMyCustoms color="#CDD1D1" />;
        break;
      default:
        break;
    }
    return iconMenu;
  };

  /**
   * @method fetchMenuSchema
   */
  const fetchMenuSchema = async (profile, menuType, compId) => {
    const getProfile = giveProfile(profile);
    await getMenuSchema({
      variables: {
        input: {
          profile: getProfile,
          menuType,
          ...(compId && { companyId: compId }),
        },
      },
      onCompleted: (data) => {
        if (data?.MenuSchema?.data?.[0]?.menuType === 'global-menu') {
          const stateData = data?.MenuSchema?.data
            ?.filter((ele) => {
              if (ele.name === 'MyEntities') {
                return displayMyEntitiesTab;
              }
              if (ele.name === 'MyTimeline') {
                return displayTimelineTab;
              }
              if (ele.name === 'SupplierDirectory') {
                return !hideMySuppliersTab;
              }
              if (ele.name === 'MyCustoms') {
                return hideCustomsMenu;
              }
              return true;
            })
            ?.map((ele) => ({
              ...ele,
              icon: iconMaster(ele.icon),
            }));
          setGlobalMenu(stateData);
        }
        if (data?.MenuSchema?.data?.[0]?.menuType === 'relational-menu') {
          const stateData = data?.MenuSchema?.data
            ?.filter((ele) => {
              if (ele.name === 'Pricing') {
                return checkPermission(
                  giveProfile(relation),
                  'Pricing',
                  'View Opportunity',
                  'E'
                );
              }
              return true;
            })
            .map((ele) => ({ ...ele, icon: iconMaster(ele.icon) }));

          setRelationalMenu(stateData);
        }
      },
    });
  };

  const fetchMenusData = async (rel, compId) => {
    if (rel) {
      await fetchMenuSchema(rel, ['global-menu']);
    }
    if (companyId) {
      await fetchMenuSchema(rel, ['relational-menu'], compId);
    }
  };

  useEffect(() => {
    fetchMenusData(relation, companyId);
    return () => {};
  }, [
    relation,
    companyId,
    displayMyEntitiesTab,
    displayTimelineTab,
    hideCustomsMenu,
  ]);

  // const leftmenuSchema = [
  //   {
  //     type: 'text',
  //     name: 'MyDashboard',
  //     path: `/app/${relation}/dashboard`,
  //     placeholder: t('menuSchema.mydashboard'),
  //     icon: <MenuDashboard />,
  //   },
  //   {
  //     type: 'text',
  //     name: 'MyProfile',
  //     path: `/app/${relation}/profile`,
  //     placeholder: t('menuSchema.myaccount'),
  //     icon: <MenuMyProfile />,
  //   },
  //   // {
  //   //   type: 'text',
  //   //   name: 'MyProfile',
  //   //   path: `/app/${relation}/my-timeline`,
  //   //   placeholder: t('menuSchema.mytimeline'),
  //   //   icon: <TimezoneIcon />,
  //   // },
  //   {
  //     type: 'text',
  //     name: 'MyCompany',
  //     path: `/app/${relation}/my-company`,
  //     placeholder: t('menuSchema.mycompany'),
  //     icon: <MenuMyCompany />,
  //   },
  //   ...(relation === 'forwarder'
  //     ? [
  //         {
  //           type: 'text',
  //           name: 'OnboardPartners',
  //           path: `/app/${relation}/onboard-partners`,
  //           placeholder: 'Onboard Partners',
  //           icon: <MenuMyCompany />,
  //         },
  //       ]
  //     : []),
  //   ...(relation === 'supplier'
  //     ? [
  //         {
  //           type: 'text',
  //           name: 'SupplierDirectory',
  //           path: `/app/${relation}/supplier-directory`,
  //           placeholder: t('menuSchema.mysuppliers'),
  //           icon: <MenuMySuppliers />,
  //         },
  //       ]
  //     : []),
  //   {
  //     type: 'text',
  //     name: 'InvitePartners',
  //     path: `/app/${relation}/invite-partners`,
  //     placeholder: t('menuSchema.invitepartners'),
  //     icon: <MenuInvitePartner />,
  //   },
  // ];
  // const supplierMenuSchema = [
  //   {
  //     type: 'text',
  //     name: 'Dashboard',
  //     path: `/app/buyer/${companyId}/company-dashboard`,
  //     placeholder: t('supplierMenuSchema.mydashboard'),
  //     icon: <MenuDashboard />,
  //   },
  //   {
  //     type: 'text',
  //     name: 'Order',
  //     path: `/app/buyer/${companyId}/order-list`,
  //     placeholder: t('supplierMenuSchema.orders'),
  //     icon: <MenuOrders />,
  //   },
  //   {
  //     type: 'text',
  //     name: 'Booking',
  //     path: `/app/buyer/${companyId}/booking-list`,
  //     placeholder: t('supplierMenuSchema.bookings'),
  //     icon: <MenuBookings />,
  //   },
  //   {
  //     type: 'text',
  //     name: 'Shipment',
  //     path: `/app/buyer/${companyId}/shipment-list`,
  //     placeholder: t('supplierMenuSchema.shipments'),
  //     icon: <MenuShipments />,
  //   },
  // ];
  // const buyerMenuSchema = [
  //   {
  //     type: 'text',
  //     name: 'Dashboard',
  //     path: `/app/supplier/${companyId}/company-dashboard`,
  //     placeholder: t('buyerMenuSchema.mydashboard'),
  //     icon: <MenuDashboard />,
  //   },
  //   {
  //     type: 'text',
  //     name: 'Order',
  //     path: `/app/supplier/${companyId}/order-list`,
  //     placeholder: t('buyerMenuSchema.orders'),
  //     icon: <MenuOrders />,
  //   },
  //   {
  //     type: 'text',
  //     name: 'Booking',
  //     path: `/app/supplier/${companyId}/booking-list`,
  //     placeholder: t('buyerMenuSchema.bookings'),
  //     icon: <MenuBookings />,
  //   },
  //   {
  //     type: 'text',
  //     name: 'Shipment',
  //     path: `/app/supplier/${companyId}/shipment-list`,
  //     placeholder: t('buyerMenuSchema.shipments'),
  //     icon: <MenuShipments />,
  //   },
  // ];
  const languageSchema = [
    { label: 'English', value: 'en' },
    { label: 'Turkish/Türkçe', value: 'tr' },
    { label: 'Spanish/Español', value: 'es' },
  ];

  // const forwarderMenuSchema = [
  //   {
  //     type: 'text',
  //     name: 'Dashboard',
  //     path: `/app/forwarder/${companyId}/company-dashboard`,
  //     placeholder: t('forwarderMenuSchema.mydashboard'),
  //     icon: <MenuDashboard />,
  //   },
  //   {
  //     type: 'text',
  //     name: 'Booking',
  //     path: `/app/forwarder/${companyId}/booking-list`,
  //     placeholder: t('forwarderMenuSchema.bookings'),
  //     icon: <MenuBookings />,
  //   },
  //   {
  //     type: 'text',
  //     name: 'Shipment',
  //     path: `/app/forwarder/${companyId}/shipment-list`,
  //     placeholder: t('forwarderMenuSchema.shipments'),
  //     icon: <MenuShipments />,
  //   },
  // ];
  // const customBrokerMenuSchema = [
  //   {
  //     type: 'text',
  //     name: 'Dashboard',
  //     path: `/app/customBroker/${companyId}/company-dashboard`,
  //     placeholder: t('forwarderMenuSchema.mydashboard'),
  //     icon: <MenuDashboard />,
  //   },
  //   {
  //     type: 'text',
  //     name: 'Shipment',
  //     path: `/app/customBroker/${companyId}/shipment-list`,
  //     placeholder: 'Shipments',
  //     icon: <MenuShipments />,
  //   },
  // ];
  const accountMenu = [
    {
      type: 'text',
      name: 'Logout',
      path: '/login',
      placeholder: 'Logout',
    },
    {
      type: 'text',
      name: 'FAQ',
      path: '/',
      placeholder: 'FAQ',
    },
    {
      type: 'text',
      name: 'Terms & Conditions',
      path: '/',
      placeholder: 'Terms & Conditions',
    },
  ];
  const filterOptionCreatedOnSchema = [
    { label: 'Today', value: 'Today', id: 'Today' },
    { label: 'This week', value: 'This week', id: 'This week' },
    { label: 'This month', value: 'This month', id: 'This month' },
    { label: 'This quarter', value: 'This quarter', id: 'This quarter' },
    { label: 'This year', value: 'This year', id: 'This year' },
    { label: 'Custom', value: 'Custom', id: 'Custom' },
  ];

  const currentCustomStatusSchema = [
    {
      label: 'In Progress',
      value: 'In Progress',
    },
    {
      label: 'Not Started',
      value: 'Not Started',
    },
    {
      label: 'Customs Completed',
      value: 'Customs Completed',
    },
  ];

  // const dataTab = (key) => {
  //   let data = [{ label: '', value: '' }];
  //   switch (key) {
  //     case 'To Do':
  //       data = [
  //         { label: 'New', value: 'New' },
  //         { label: 'Partially Accepted', value: 'Partially Accepted' },
  //         { label: 'Rejected', value: 'Rejected' },
  //         { label: 'Change Requested', value: 'Change Requested' },
  //       ];
  //       break;
  //     case 'Accepted':
  //       data = [{ label: 'Accepted', value: 'Accepted' }];
  //       break;
  //     case 'Production':
  //       data = [
  //         { label: 'In Production', value: 'In Production' },
  //         { label: 'Production Completed', value: 'Production Completed' },
  //       ];
  //       break;
  //     case 'Cargo Ready':
  //       data = [
  //         { label: 'Partially Cargo Ready', value: 'Partially Cargo Ready' },
  //         { label: 'Cargo Ready', value: 'Cargo Ready' },
  //         { label: 'Partially Packed', value: 'Partially Packed' },
  //         { label: 'Partially Booked', value: 'Partially Booked' },
  //         { label: 'Partially Shipped', value: 'Partially Shipped' },
  //       ];
  //       break;
  //     case 'Cargo Delivery':
  //       data = [
  //         { label: 'Packed', value: 'Packed' },
  //         { label: 'Partially Shipped', value: 'Partially Shipped' },
  //         { label: 'Shipped', value: 'Shipped' },
  //         { label: 'Partially Booked', value: 'Partially Booked' },
  //         { label: 'Booked', value: 'Booked' },
  //       ];
  //       break;

  //     default:
  //       data = [
  //         { label: 'New', value: 'New' },
  //         { label: 'Partially Accepted', value: 'Partially Accepted' },
  //         { label: 'Accepted', value: 'Accepted' },
  //         { label: 'Rejected', value: 'Rejected' },
  //         { label: 'Change Requested', value: 'Change Requested' },
  //         { label: 'In Production', value: 'In Production' },
  //         { label: 'Production Completed', value: 'Production Completed' },
  //         { label: 'Partially Cargo Ready', value: 'Partially Cargo Ready' },
  //         { label: 'Cargo Ready', value: 'Cargo Ready' },
  //         { label: 'Partially Packed', value: 'Partially Packed' },
  //         { label: 'Partially Booked', value: 'Partially Booked' },
  //         { label: 'Partially Shipped', value: 'Partially Shipped' },
  //         { label: 'Packed', value: 'Packed' },
  //         { label: 'Shipped', value: 'Shipped' },
  //         { label: 'Booked', value: 'Booked' },
  //       ];
  //       break;
  //   }
  //   return data;
  // };
  // const params = new URLSearchParams(window.location.search);
  // const satusOptionSchema = dataTab(params.get('urlID') || 'All');

  const getStatusOptions = (key) => {
    const storedStatusList =
      JSON.parse(window.localStorage.getItem('POStatusList')) || [];
    const statusGroup =
      storedStatusList.find((item) => item._id === key) ||
      storedStatusList?.[0];
    const subStatuses = statusGroup?.subStatus || [];
    const uniqueStatuses = [...new Set(subStatuses)];
    return uniqueStatuses.map((status) => ({ label: status, value: status }));
  };
  const bulkActionSchema = () => {
    const POStatusList =
      JSON.parse(window.localStorage.getItem('POStatusList')) || [];
    const SchemaOption = POStatusList?.[0]?.subStatus.includes('In Production');
    let bulkActionOptions = [];
    let bulkActionOptionsDetails = [];
    if (SchemaOption) {
      bulkActionOptions = [
        {
          label: {
            en: 'Accept Orders',
            es: 'Aceptar pedidos',
            tr: 'Siparişleri kabul et',
          },
          value: 'acceptOrders',
          detailsvalue: 'Accepted',
          name: 'bulkAction',
          action: 'New',
        },
        {
          label: {
            en: 'In Production',
            es: 'En producción',
            tr: 'Üretimde',
          },
          value: 'inProduction',
          detailsvalue: 'In Production',
          name: 'bulkAction',
          action: 'Accepted',
        },
        {
          label: {
            en: 'Production Completed',
            es: 'Producción completada',
            tr: 'Üretim tamamlandı',
          },
          value: 'productionCompleted',
          detailsvalue: 'Production Completed',
          name: 'bulkAction',
          action: 'In Production',
        },
        {
          label: {
            en: 'Mark Cargo Ready',
            es: 'Marcar carga lista',
            tr: 'Yükü hazır olarak işaretle',
          },
          value: 'markCargoReady',
          detailsvalue: 'Cargo Ready',
          name: 'bulkAction',
          action: 'Production Completed',
        },
        ...(companyId
          ? [
              {
                label: {
                  en: 'Bulk Packaging',
                  es: 'Empaque masivo',
                  tr: 'Toplu paketleme',
                },
                value: 'bulkPackaging',
                name: 'bulkAction',
                action: 'All',
              },
            ]
          : []),
        ...(checkPermission(giveProfile(relation), 'Order', 'assignOwner')
          ? [
              {
                label: {
                  en: 'Assign Ownership',
                  es: 'Asignar propiedad',
                  tr: 'Mülkiyeti ata',
                },
                value: 'assignOwnership',
                name: 'bulkAction',
                action: 'New',
              },
            ]
          : []),
        ...(checkPermission(giveProfile(relation), 'Order', 'transferOwner')
          ? [
              {
                label: {
                  en: 'Transfer Ownership',
                  es: 'Transferir propiedad',
                  tr: 'Mülkiyetin Devri',
                },
                value: 'transferOwnership',
                name: 'bulkAction',
                action: 'New',
              },
            ]
          : []),
        ...(showCreateSingleOrder
          ? [
              {
                label: {
                  en: 'Create Single Order',
                  es: 'Crear Pedido Individual',
                  tr: 'Tekil Sipariş Oluştur',
                },
                value: 'createSingleOrder',
                name: 'bulkAction',
                action: 'New',
                type: 'button',
              },
            ]
          : []),
      ];
    } else {
      bulkActionOptions = [
        {
          label: {
            en: 'Accept Orders',
            es: 'Aceptar pedidos',
            tr: 'Siparişleri kabul et',
          },
          value: 'acceptOrders',
          detailsvalue: 'Accepted',
          name: 'bulkAction',
          action: 'New',
        },
        {
          label: {
            en: 'Mark Cargo Ready',
            es: 'Marcar carga lista',
            tr: 'Yükü hazır olarak işaretle',
          },
          value: 'markCargoReady',
          detailsvalue: 'Cargo Ready',
          name: 'bulkAction',
          action: 'Accepted',
        },
        ...(companyId
          ? [
              {
                label: {
                  en: 'Bulk Packaging',
                  es: 'Empaque masivo',
                  tr: 'Toplu paketleme',
                },
                value: 'bulkPackaging',
                name: 'bulkAction',
                action: 'All',
              },
            ]
          : []),
        ...(checkPermission(giveProfile(relation), 'Order', 'assignOwner')
          ? [
              {
                label: {
                  en: 'Assign Ownership',
                  es: 'Asignar propiedad',
                  tr: 'Mülkiyeti ata',
                },
                value: 'assignOwnership',
                name: 'bulkAction',
                action: 'New',
              },
            ]
          : []),
        ...(checkPermission(giveProfile(relation), 'Order', 'transferOwner')
          ? [
              {
                label: {
                  en: 'Transfer Ownership',
                  es: 'Transferir propiedad',
                  tr: 'Mülkiyetin Devri',
                },
                value: 'transferOwnership',
                name: 'bulkAction',
                action: 'New',
              },
            ]
          : []),
        ...(showCreateSingleOrder
          ? [
              {
                label: {
                  en: 'Create Single Order',
                  es: 'Crear Pedido Individual',
                  tr: 'Tekil Sipariş Oluştur',
                },
                value: 'createSingleOrder',
                name: 'bulkAction',
                action: 'New',
                type: 'button',
              },
            ]
          : []),
      ];
    }
    if (SchemaOption) {
      bulkActionOptionsDetails = [
        {
          label: {
            en: 'Accept ',
            es: 'Aceptar ',
            tr: 'kabul et',
          },
          value: 'acceptOrders',
          detailsvalue: 'Accepted',
          name: 'bulkAction',
          action: 'New',
        },
        {
          label: {
            en: 'In Production',
            es: 'En producción',
            tr: 'Üretimde',
          },
          value: 'inProduction',
          detailsvalue: 'In Production',
          name: 'bulkAction',
          action: 'Accepted',
        },
        {
          label: {
            en: 'Production Completed',
            es: 'Producción completada',
            tr: 'Üretim tamamlandı',
          },
          value: 'productionCompleted',
          detailsvalue: 'Production Completed',
          name: 'bulkAction',
          action: 'In Production',
        },
        {
          label: {
            en: 'Mark Cargo Ready',
            es: 'Marcar carga lista',
            tr: 'Yükü hazır olarak işaretle',
          },
          value: 'markCargoReady',
          detailsvalue: 'Cargo Ready',
          name: 'bulkAction',
          action: 'Production Completed',
        },
        {
          label: {
            en: 'Bulk Packaging',
            es: 'Empaque masivo',
            tr: 'Toplu paketleme',
          },
          value: 'bulkPackaging',
          name: 'bulkAction',
          action: 'All',
        },
        ...(checkPermission(giveProfile(relation), 'Order', 'assignOwner')
          ? [
              {
                label: {
                  en: 'Assign Ownership',
                  es: 'Asignar propiedad',
                  tr: 'Mülkiyeti ata',
                },
                value: 'assignOwnership',
                name: 'bulkAction',
                action: 'New',
              },
            ]
          : []),
        ...(checkPermission(giveProfile(relation), 'Order', 'transferOwner')
          ? [
              {
                label: {
                  en: 'Transfer Ownership',
                  es: 'Transferir propiedad',
                  tr: 'Mülkiyetin Devri',
                },
                value: 'transferOwnership',
                name: 'bulkAction',
                action: 'New',
              },
            ]
          : []),
      ];
    } else {
      bulkActionOptionsDetails = [
        {
          label: {
            en: 'Accept',
            es: 'Aceptar',
            tr: 'kabul et',
          },
          value: 'acceptOrders',
          detailsvalue: 'Accepted',
          name: 'bulkAction',
          action: 'New',
        },
        {
          label: {
            en: 'Mark Cargo Ready',
            es: 'Marcar carga lista',
            tr: 'Yükü hazır olarak işaretle',
          },
          value: 'markCargoReady',
          detailsvalue: 'Cargo Ready',
          name: 'bulkAction',
          action: 'Accepted',
        },
        {
          label: {
            en: 'Bulk Packaging',
            es: 'Empaque masivo',
            tr: 'Toplu paketleme',
          },
          value: 'bulkPackaging',
          name: 'bulkAction',
          action: 'All',
        },
        ...(checkPermission(giveProfile(relation), 'Order', 'assignOwner')
          ? [
              {
                label: {
                  en: 'Assign Ownership',
                  es: 'Asignar propiedad',
                  tr: 'Mülkiyeti ata',
                },
                value: 'assignOwnership',
                name: 'bulkAction',
                action: 'New',
              },
            ]
          : []),
        ...(checkPermission(giveProfile(relation), 'Order', 'transferOwner')
          ? [
              {
                label: {
                  en: 'Transfer Ownership',
                  es: 'Transferir propiedad',
                  tr: 'Mülkiyetin Devri',
                },
                value: 'transferOwnership',
                name: 'bulkAction',
                action: 'New',
              },
            ]
          : []),
      ];
    }
    return {
      bulkActionOptions,
      bulkActionOptionsDetails,
    };
  };

  const params = new URLSearchParams(window.location.search);
  const satusOptionSchema = getStatusOptions(params.get('urlID') || 'All');

  const notificationsOptionSchema = [
    { label: 'Milestones', value: 'Milestones' },
    { label: 'Actions', value: 'Actions' },
    { label: 'Approvals', value: 'Approvals' },
    { label: 'Chats & Mentions', value: 'Chats & Mentions' },
    { label: 'Documents', value: 'Documents' },
    { label: 'PO Changes', value: 'PO Changes' },
  ];
  /*   const participantsOptionSchema = [
    { label: 'User Name1', value: 'User Name1' },
    { label: 'User Name2', value: 'User Name2' },
    { label: 'User Name3', value: 'User Name3' },
  ]; */
  const actionOptions = [
    { label: 'Create Booking', value: 'Create Booking' },
    { label: 'View Booking', value: 'View Booking' },
  ];
  const ownerOptions = [{ label: 'Self', value: 'Self' }];
  if (giveProfile(relation) === 'buyer') {
    ownerOptions.push({
      label: 'Supplier',
      value: 'Supplier',
    });
  }
  if (giveProfile(relation) === 'supplier') {
    ownerOptions.push({
      label: 'Buyer',
      value: 'Buyer',
    });
  }
  const modeOptions = [
    { label: 'Air', value: 'Air' },
    { label: 'Ocean', value: 'Ocean' },
    { label: 'Inland', value: 'Inland' },
    // { label: 'Inland Pick-up', value: 'Inland Pick-up' },
    // { label: 'Inland Delivery', value: 'Inland Delivery' },
  ];
  const quoteStatusOptions = [
    { label: 'Quotation Requested', value: 'Quotation Requested' },
    { label: 'Quotation Pending', value: 'Quotation Pending' },
    { label: 'Quotation Expired', value: 'Quotation Expired' },
  ];

  /*  const dateOptions = [
    { label: 'Monthly', value: 'Monthly' },
    { label: 'Quaterly', value: 'Quaterly' },
    { label: 'Yearly', value: 'Yearly' },
    { label: 'Custom', value: 'Custom', id: 'Custom' },
  ]; */

  const forwarderOptions = [];
  const supplierOptions = [];
  const participantsOptions = [];
  const locationOptions = [];

  const shipmentDataTab = (key) => {
    let data = [{ label: '', value: '' }];
    switch (key) {
      case 'All':
        data = [
          { label: 'Ready', value: 'Ready' },
          { label: 'Departed', value: 'Departed' },
          { label: 'Arrived', value: 'Arrived' },
          // { label: 'Customs Clearance', value: 'Customs Clearance' },
          // { label: 'Customs Started', value: 'Customs Started' },
          // { label: 'Customs In-progress', value: 'Customs In-progress' },
          // { label: 'Customs Completed', value: 'Customs Completed' },
          { label: 'Delivered', value: 'Delivered' },
        ];
        break;
      // case 'Pick-Up Shipment':
      // case 'Delivery Shipment':
      //   data = [
      //     { label: 'Ready', value: 'Ready' },
      //     { label: 'Departed', value: 'Departed' },
      //     { label: 'Arrived', value: 'Arrived' },
      //     { label: 'Delivered', value: 'Delivered' },
      //   ];
      //   break;
      case 'Ready':
        data = [{ label: 'Ready', value: 'Ready' }];
        break;
      case 'Departed':
        data = [{ label: 'Departed', value: 'Departed' }];
        break;
      case 'Arrived':
        data = [{ label: 'Arrived', value: 'Arrived' }];
        break;
      case 'Delivered':
        data = [{ label: 'Delivered', value: 'Delivered' }];
        break;
      case 'Customs Clearance':
        data = [
          { label: 'Customs Clearance', value: 'Customs Clearance' },
          { label: 'Customs Started', value: 'Customs Started' },
          { label: 'Customs In-progress', value: 'Customs In-progress' },
          { label: 'Customs Completed', value: 'Customs Completed' },
        ];
        break;

      default:
        data = [{ label: '', value: '' }];
        break;
    }
    return data;
  };
  const shipmentsStatusOptions = shipmentDataTab(params.get('urlID') || 'All');
  const shipmentsEventsOptions = [
    { label: 'On Time', value: 'On Time' },
    { label: 'Delay', value: 'Delay' },
    { label: 'Behind schedule', value: 'Behind schedule' },
  ];

  return {
    globalMenu,
    relationalMenu,
    // leftmenuSchema,
    // supplierMenuSchema,
    // buyerMenuSchema,
    // forwarderMenuSchema,
    // customBrokerMenuSchema,
    accountMenu,
    languageSchema,
    filterOptionCreatedOnSchema,
    satusOptionSchema,
    notificationsOptionSchema,
    actionOptions,
    ownerOptions,
    modeOptions,
    quoteStatusOptions,
    forwarderOptions,
    supplierOptions,
    shipmentsStatusOptions,
    shipmentsEventsOptions,
    participantsOptions,
    locationOptions,
    // dateOptions,
    bulkActionSchema,
    currentCustomStatusSchema,
  };
};

export default menuSchema;
